import { useTheme } from "@mui/material";
import { createSxStyles } from "@common/createSxStyles";

export const useFrameChangeConfirmationStyles = () => {
    const theme = useTheme();
    return createSxStyles({
        figures: {
            display: "flex",
            flexDirection: "column",
            gap: 1,
            marginBottom: theme.spacing(2),
        },
        figureRow: {
            display: "flex",
            gap: 1,
        },
        figureLabel: {
            fontSize: "0.85rem",
            color: theme.palette.text.secondary,
        },
        figureValue: {
            fontSize: "0.85rem",
            fontWeight: theme.typography.fontWeightBold,
            color: theme.palette.primary.dark,
        },
        mappingColumns: {
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: theme.spacing(4),
            marginBottom: theme.spacing(2),
            [theme.breakpoints.down("md")]: {
                gridTemplateColumns: "1fr",
            },
        },
        mappingRow: {
            display: "grid",
            gridTemplateColumns: "1fr auto 72px",
            alignItems: "center",
            columnGap: theme.spacing(1),
        },
        sourceLabel: {
            fontSize: "0.85rem",
            color: theme.palette.text.secondary,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
        },
        arrow: {
            fontSize: "0.85rem",
            color: theme.palette.text.secondary,
        },
    });
};
